// import AOS from "aos";
// import "aos/dist/aos.css";
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";


// const SellerLandingPage = () => {
//   const [currentStory, setCurrentStory] = useState(0);

//   const stats = [
//     { number: '14 Lakh+', label: 'Active Sellers', color: '#e63963' },
//     { number: '24x7', label: 'Seller Support', color: '#e63963' },
//     { number: '7', label: 'Days Payment', color: '#e63963' },
//     { number: '19000+', label: 'PIN codes', color: '#e63963' }
//   ];

//   const whySell = [
//     { img:"/images/seller/__Opportunity.svg", title: 'Opportunity', desc: 'Sell to 50 crore+ customers across 19,000+ pin codes' },
//     { img:"/images/seller/__Ease.svg", title: 'Ease of Doing Business', desc: 'One click seller registration and free listing' },
//     { img:"/images/seller/__Growth.svg", title: 'Growth', desc: 'Get business insights and training to grow your business' },
//     { img:"/images/seller/__Support.svg", title: 'Additional Support', desc: 'Seller support available 24x7 to resolve your queries' }
//   ];

//   const journey = [
//     { imgjourny: '/images/seller/create-icon.svg', title: 'Create', desc: 'Create your online shop within minutes' },
//     { imgjourny: '/images/seller/list_icon.svg', title: 'List', desc: 'List unlimited products with ease' },
//     { imgjourny: '/images/seller/orders-icon.svg', title: 'Orders', desc: 'Receive orders directly from customers' },
//     { imgjourny: '/images/seller/shipment-icon.svg', title: 'Shipment', desc: 'Quick and easy shipment process' },
//     { imgjourny: '/images/seller/payment-icon.svg', title: 'Payment', desc: 'Get timely payments directly to your account' }
//   ];

//   const tools = [
//     { imgtool: '/images/seller/Fulfillment.svg', title: 'Fulfilment by Flipkart', desc: 'Store and ship your products with Flipkart' },
//     { imgtool: '/images/seller/__Ads.svg', title: 'Flipkart Ads', desc: 'Advertise your products to boost visibility' },
//     { imgtool: '/images/seller/__Shopping_fest.svg', title: 'Shopping Festivals', desc: 'Participate in special sales events' },
//     { imgtool: '/images/seller/__learning.svg', title: 'Learning Center', desc: 'Learn how to grow your online business' },
//     { imgtool: '/images/seller/__Account_mana.svg', title: 'Account Management', desc: 'Manage orders, inventory & catalogue' },
//     { imgtool: '/images/seller/__App.svg', title: 'Mobile App', desc: 'Manage your business on the go' }
//   ];

//     const stories = [
//     {
//       name: "Deep Bajaj",
//       role: "Sirona Hygiene",
//       quote:
//         "Flipkart created awareness about intimate & menstrual hygiene products. Their team's involvement made our innovative products household favourites.",
//       image: "/images/user1.png"
//     },
//     {
//       name: "Amit Sharma",
//       role: "Fashion Seller",
//       quote:
//         "With Flipkart’s reach, our brand scaled faster than expected.",
//       image: "/images/user2.png"
//     }
//   ];

//   useEffect(() => {
//   AOS.init({
//     duration: 800,
//     once: true, // animation only once
//     easing: "ease-in-out",
//   });
// }, []);

// useEffect(() => {
//   const observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("show");
//           observer.unobserve(entry.target); // animate once
//         }
//       });
//     },
//     {
//       threshold: 0.15,
//       rootMargin: "0px 0px -50px 0px",
//     }
//   );

//   document
//     .querySelectorAll(".animate-on-scroll")
//     .forEach((el) => observer.observe(el));

//   return () => observer.disconnect();
// }, []);




//   const shopsyFeatures = [
//   {
//     imgfeature: "/images/seller/zero_return.svg",
//     title: "0 Penalty"
//   },
//   {
//     imgfeature: "/images/seller/__Growth.svg",
//     title: "Grow in 6 Simple Steps"
//   },
//   {
//     imgfeature: "/images/seller/lowestcost.svg",
//     title: "Lowest Cost of doing business"
//   }
// ];


//   return (
//     <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#fff' }}>
//       {/* Navigation */}
//       <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
//         <div className="container-fluid px-4">
//           <a className="navbar-brand d-flex align-items-center" href="#">
//             <div className="nav-logo">
//             <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
//         </div>
//           </a>
//           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto align-items-lg-center">
//               <li className="nav-item">
//                 <a className="nav-link" href="#" style={{ color: '#212121' }}>Sell Online</a>
//               </li>
//               <li className="nav-item">
//                 <a className="nav-link" href="#" style={{ color: '#212121' }}>Fees and Commission</a>
//               </li>
//               <li className="nav-item">
//                 <a className="nav-link" href="#" style={{ color: '#212121' }}>Learn</a>
//               </li>
//               <li className="nav-item ms-lg-2">
//                 <Link to="/login">
//                 <button className="btn px-3" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963', fontWeight: '500' }}>Login</button>
//                 </Link>
//               </li>
//               <li className="nav-item ms-lg-2">
//                 <Link to="/register">
//                 <button className="btn px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none', fontWeight: '600' }}>Start Selling</button>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <section style={{ background: "radial-gradient(circle, rgba(230, 135, 160, 1) 5%, rgba(255, 245, 248, 1) 100%)", padding: '60px 0' }}>
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-6 mb-4 mb-lg-0">
//               <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', display: 'inline-block' }}>
//                 <h1 className="fw-bold mb-3" style={{ color: '#e63963', fontSize: '48px' }}>Ab kya<br/>₹0% comission,<br/>pe ayega dhyaan,<br/>full on nacho!</h1>
//                 <p className="text-muted mb-3">Earn without worrying about commission</p>
//                 <button className="btn btn-lg px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none', fontWeight: '600' }}>SAVE NOW!</button>
//               </div>
//             </div>
//             <div className="col-lg-6 text-center">
//               <div style={{ fontSize: '120px' }}><img src='/images/seller/LandingBanner-removebg-preview.png'/></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-4" style={{ backgroundColor: '#fff' }}>
//         <div className="container">
//           <div className="row g-4">
//             {stats.map((stat, index) => (
//               <div key={index} className="col-6 col-lg-3 text-center">
//                 <h2 className="fw-bold mb-1" style={{ color: stat.color, fontSize: '36px' }}>{stat.number}</h2>
//                 <p className="text-muted mb-0" style={{ fontSize: '14px' }}>{stat.label}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Why Sellers Love Section */}
//       <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
//         <div className="container">
//           <h1 className="text-center mb-4">Why do <span style={{ color: '#e63963' }}>sellers love selling on Flipkart?</span></h1>
//           <p className="para text-center text-muted mb-5">At Seller HQ, we look at the entire experience to help you start, build and sustain an online business. Here is what we provide to all our sellers and aim to make their experience truly wonderful and fulfilling.</p>
//           <div className="row g-4">
//             <div className="col-lg-8">
//               <div className="row g-4">
//                 {whySell.map((item, index) => (
//                   <div key={index} className="col-md-6">
//                     <div
//                       className="p-4 whycard"
//                       data-aos="fade-up"
//                       data-aos-delay={index * 100}
//                       style={{
//                         backgroundColor: "#fff",
//                         borderRadius: "8px",
//                         height: "100%",
//                       }}
//                     >
//                       <div className="mb-3 whyimg d-flex align-items-center" style={{ fontSize: "12px" }}>
//                         <img src={item.img} alt={item.title} />
//                         <h4 className="fw-bold mb-2 ms-2">{item.title}</h4>
//                       </div>
//                       <p className="text-muted mb-0" style={{ fontSize: "15px" }}>
//                         {item.desc}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="col-lg-4 text-center">
//                 <img
//                 src='/images/seller/position1.webp'
//                 className='whyright'
//                 />            
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Seller Success Stories */}
//       <section className="py-5" style={{ backgroundColor: '#fff' }}>
//         <div className="container">
//             <div className="row">
//                 <div className="col-lg-6 sellersuccess">
//           <h1 className="mb-4" style={{ color: '#e63963' }}>Seller Success Stories</h1>
//           <p className="para text-bold mb-4">14 Lakhs+ sellers trust Flipkart for their online success business.</p>
//           <div className="row">
//             <div className="col-lg-8">
//               <button className="btn btn-sm mb-3 para" style={{ border: '1px solid #e63963', color: '#e63963', backgroundColor: 'white', width: '150px' }}>See All Stories</button>
//             </div>
//             </div>
//             </div>
//             <div className="col-lg-6 position-relative d-flex justify-content-center">
//               <div className="seller-slider-card">

//                 {/* Left Arrow */}
//                 <button
//                   className="slider-arrow left"
//                   onClick={() =>
//                     setCurrentStory(
//                       currentStory === 0 ? stories.length - 1 : currentStory - 1
//                     )
//                   }
//                 >
//                   ‹
//                 </button>

//                 {/* Right Arrow */}
//                 <button
//                   className="slider-arrow right"
//                   onClick={() =>
//                     setCurrentStory(
//                       currentStory === stories.length - 1 ? 0 : currentStory + 1
//                     )
//                   }
//                 >
//                   ›
//                 </button>

//                 {/* Profile */}
//                 <div className="profile-wrap">
//                   <div className="profile-bg">
//                     <img
//                       src={stories[currentStory].image}
//                       alt={stories[currentStory].name}
//                     />
//                   </div>
//                 </div>

//                 <h5 className="fw-bold mt-3">
//                   {stories[currentStory].name},
//                 </h5>
//                 <p className="text-muted mb-3">
//                   {stories[currentStory].role}
//                 </p>

//                 <p className="story-text">
//                   {stories[currentStory].quote}
//                 </p>

//                 {/* Dots */}
//                 <div className="dots">
//                   {stories.map((_, index) => (
//                     <span
//                       key={index}
//                       className={index === currentStory ? "dot active" : "dot"}
//                       onClick={() => setCurrentStory(index)}
//                     />
//                   ))}
//                 </div>

//               </div>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* Your Journey Section */}
//       <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
//         <div className="container">
//           <h1 className="text-center mb-2"><span style={{ color: '#e63963' }}>Your Journey</span> on Flipkart</h1>
//           <p className="para text-center text-muted mb-5">Starting your online business with us? It's super easy. Follow these 5 easy steps that you don't want to miss</p>
//           <div className="row g-4">
//             {journey.map((item, index) => (
//               <div key={index} className="col-6 col-md-4 col-lg text-center">
//                 <div className="p-4 animate-on-scroll" style={{ backgroundColor: '#fff', borderRadius: '8px', height: '100%' }}>
//                   <div className="mb-3"><img src={item.imgjourny} alt={item.title} className='journyimg' /></div>
//                   <h3 className="fw-bold mb-2">{item.title}</h3>
//                   <p className="text-muted small mb-0" style={{ fontSize: '15px' }}>{item.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="text-center mt-4">
//             <button className="btn para" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963', fontWeight: '500' }}>Download Seller Kit</button>
//           </div>
//         </div>
//       </section>

//       {/* Tools Section */}
//       <section className="py-5" style={{ backgroundColor: '#fff' }}>
//         <div className="container">
//           <h1 className="text-center mb-2">Access our tools to <span style={{ color: '#e63963' }}>grow faster</span> on Flipkart</h1>
//           <p className="para text-center text-muted mb-5">With a wide range of tools at your fingertips, we empower you to set up and manage your business seamlessly.</p>
//           <div className="row g-4">
//             {tools.map((tool, index) => (
//               <div key={index} className="col-md-6 col-lg-4">
//                 <div className="p-4 h-100 animate-on-scroll" style={{ backgroundColor: '#f7f9fc', borderRadius: '8px' }}>
//                   <div className="mb-3" style={{ fontSize: '32px', display:"flex", alignItems:"center" }}><img src={tool.imgtool} alt={tool.title} className='toolimg'/><h4 className="fw-bold mb-2 ms-2">{tool.title}</h4></div>
//                   <p className="text-muted small mb-3" style={{ fontSize: '15px' }}>{tool.desc}</p>
//                   <a href="#" style={{ color: '#2874f0', fontSize: '13px', textDecoration: 'none' }}>Learn More →</a>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Shopsy Section */}
//         <section
//         className="py-5 text-center"
//         style={{ backgroundColor: "rgba(var(--bs-white-rgb), var(--bs-bg-opacity))" }}
//         >
//         <div className="container">
//             <div
//             className="mb-4"
//             style={{ fontSize: "48px", fontWeight: "bold", color: "#6C5CE7" }}
//             >
//             <img
//                 src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png"
//                 alt="logo"
//                 className="brandlogo"
//             />
//             </div>

//             <p className="para mb-2 fw-bold">Your gateway to selling online</p>

//             <div className="row justify-content-center mt-5" style={{border:"#e63963 1px solid", borderRadius:"8px", padding:"20px"}}>
//             {shopsyFeatures.map((item, index) => (
//                 <div key={index} className="col-md-4 mb-4">
//                 <div ><img src={item.imgfeature} alt={item.title} className='featureimg'/></div>
//                 <h5 className="fw-bold mt-3">{item.title}</h5>
//                 </div>
//             ))}
//             </div>

//             <button
//             className="para btn px-4 mt-3"
//             style={{
//                 backgroundColor: "transparent",
//                 color: "#e63963",
//                 border: "1px solid #e63963",
//             }}
//             >
//             Explore Gharshya
//             </button>
//         </div>
//         </section>


//       {/* Platform Preview */}
//       <section className="py-5" style={{ backgroundColor: '#fff' }}>
//         <div className="container">
//           <h1 className="mb-4">Take a sneak peek 👀 into <span style={{ color: '#e63963' }}>our platform</span></h1>
//           <div className="row align-items-center">
//             <div className="col-lg-6">
//               <h3 className="fw-bold mb-3" style={{ color: '#e63963' }}>Selection Insights</h3>
//               <p className="para text-muted mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Browse through a diverse, quality goods marketplace, and take charge of the entire purchasing operation.</p>
//               <button className="btn para" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963' }}>Explore All Features</button>
//             </div>
//             <div className="col-lg-6 text-center mt-4 mt-lg-0">
//               <div style={{ backgroundColor: '#f7f9fc', padding: '40px', borderRadius: '8px' }}>
//                 <div style={{ fontSize: '80px' }}><img src="/images/seller/takesneekpeek.webp" alt="Preview" /></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Help Section */}
//       <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
//         <div className="container">
//           <div className="row align-items-center">
//             <div className="col-lg-6">
//               <h1 className="mb-4">We are happy to <span style={{ color: '#e63963' }}>help you 😊</span></h1>
//               <p className="text-muted mb-4">Get instant solutions to your queries. Browse through our extensive FAQs or get in touch with our seller support team.</p>
//               <div className="mb-3">
//                 <input type="text" className="form-control mb-2" placeholder="Name*" style={{ borderRadius: '4px' }} />
//               </div>
//               <div className="mb-3">
//                 <input type="email" className="form-control mb-2" placeholder="Email Address*" style={{ borderRadius: '4px' }} />
//               </div>
//               <div className="mb-3">
//                 <input type="tel" className="form-control mb-2" placeholder="Phone Number*" style={{ borderRadius: '4px' }} />
//               </div>
//               <button className="btn px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none' }}>Get a Callback</button>
//             </div>
//             <div className="col-lg-6 text-center mt-4 mt-lg-0">
//               <div style={{ fontSize: '120px' }}><img src="/images/seller/positionlast.webp" alt="Help" /></div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer style={{ backgroundColor: '#212121', color: '#fff', padding: '60px 0 20px' }}>
//         <div className="container">
//           <h5 className="text-center mb-4" style={{ color: '#fff' }}>Popular categories to sell across India</h5>
//           <div className="row g-4 mb-5">
//             <div className="col-6 col-md-3">
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Handloom Saree</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Kurtis</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Bedsheets</p>
//             </div>
//             <div className="col-6 col-md-3">
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Art & Craft Tools</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>T-Shirts</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Electronics</p>
//             </div>
//             <div className="col-6 col-md-3">
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Sarees</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Shirts</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Footwear</p>
//             </div>
//             <div className="col-6 col-md-3">
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Home Decor</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Books</p>
//               <p className="small mb-2" style={{ color: '#c8c8c8' }}>Furniture</p>
//             </div>
//           </div>
//           <hr style={{ borderColor: '#444', margin: '40px 0' }} />
//           <div className="text-center">
//             <p className="small" style={{ color: '#c8c8c8' }}>© 2026 Gharshya</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default SellerLandingPage;








import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


const SellerLandingPage = () => {
  const [currentStory, setCurrentStory] = useState(0);

  const stats = [
    { number: '14 Lakh+', label: 'Active Sellers', color: '#e63963' },
    { number: '24x7', label: 'Seller Support', color: '#e63963' },
    { number: '7', label: 'Days Payment', color: '#e63963' },
    { number: '19000+', label: 'PIN codes', color: '#e63963' }
  ];

  const whySell = [
    { img:"/images/seller/__Opportunity.svg", title: 'Opportunity', desc: 'Sell to 50 crore+ customers across 19,000+ pin codes' },
    { img:"/images/seller/__Ease.svg", title: 'Ease of Doing Business', desc: 'One click seller registration and free listing' },
    { img:"/images/seller/__Growth.svg", title: 'Growth', desc: 'Get business insights and training to grow your business' },
    { img:"/images/seller/__Support.svg", title: 'Additional Support', desc: 'Seller support available 24x7 to resolve your queries' }
  ];

  const journey = [
    { imgjourny: '/images/seller/create-icon.svg', title: 'Create', desc: 'Create your online shop within minutes' },
    { imgjourny: '/images/seller/list_icon.svg', title: 'List', desc: 'List unlimited products with ease' },
    { imgjourny: '/images/seller/orders-icon.svg', title: 'Orders', desc: 'Receive orders directly from customers' },
    { imgjourny: '/images/seller/shipment-icon.svg', title: 'Shipment', desc: 'Quick and easy shipment process' },
    { imgjourny: '/images/seller/payment-icon.svg', title: 'Payment', desc: 'Get timely payments directly to your account' }
  ];

  const tools = [
    { imgtool: '/images/seller/Fulfillment.svg', title: 'Fulfilment by Flipkart', desc: 'Store and ship your products with Flipkart' },
    { imgtool: '/images/seller/__Ads.svg', title: 'Flipkart Ads', desc: 'Advertise your products to boost visibility' },
    { imgtool: '/images/seller/__Shopping_fest.svg', title: 'Shopping Festivals', desc: 'Participate in special sales events' },
    { imgtool: '/images/seller/__learning.svg', title: 'Learning Center', desc: 'Learn how to grow your online business' },
    { imgtool: '/images/seller/__Account_mana.svg', title: 'Account Management', desc: 'Manage orders, inventory & catalogue' },
    { imgtool: '/images/seller/__App.svg', title: 'Mobile App', desc: 'Manage your business on the go' }
  ];

    const stories = [
    {
      name: "Deep Bajaj",
      role: "Sirona Hygiene",
      quote:
        "Flipkart created awareness about intimate & menstrual hygiene products. Their team's involvement made our innovative products household favourites.",
      image: "/images/user1.png"
    },
    {
      name: "Amit Sharma",
      role: "Fashion Seller",
      quote:
        "With Flipkart’s reach, our brand scaled faster than expected.",
      image: "/images/user2.png"
    }
  ];

  useEffect(() => {
  AOS.init({
    duration: 800,
    once: true, // animation only once
    easing: "ease-in-out",
  });
}, []);

useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
          observer.unobserve(entry.target); // animate once
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px",
    }
  );

  document
    .querySelectorAll(".animate-on-scroll")
    .forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);




  const shopsyFeatures = [
  {
    imgfeature: "/images/seller/zero_return.svg",
    title: "0 Penalty"
  },
  {
    imgfeature: "/images/seller/__Growth.svg",
    title: "Grow in 6 Simple Steps"
  },
  {
    imgfeature: "/images/seller/lowestcost.svg",
    title: "Lowest Cost of doing business"
  }
];


  return (
    <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', backgroundColor: '#fff' }}>
      {/* Navigation */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
        <div className="container-fluid px-4">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <div className="nav-logo">
            <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="logo" />
        </div>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              <li className="nav-item">
                <a className="nav-link" href="#" style={{ color: '#212121' }}>Sell Online</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" style={{ color: '#212121' }}>Fees and Commission</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" style={{ color: '#212121' }}>Learn</a>
              </li>
              <li className="nav-item ms-lg-2">
                <Link to="/login">
                <button className="btn px-3" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963', fontWeight: '500' }}>Login</button>
                </Link>
              </li>
              <li className="nav-item ms-lg-2">
                <Link to="/register">
                <button className="btn px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none', fontWeight: '600' }}>Start Selling</button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section style={{ background: "radial-gradient(circle, rgba(230, 135, 160, 1) 5%, rgba(255, 245, 248, 1) 100%)", padding: '60px 0' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 mb-4 mb-lg-0">
              <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', display: 'inline-block' }}>
                <h1 className="fw-bold mb-3" style={{ color: '#e63963', fontSize: '48px' }}>Ab kya<br/>₹0% comission,<br/>pe ayega dhyaan,<br/>full on nacho!</h1>
                <p className="text-muted mb-3">Earn without worrying about commission</p>
                <button className="btn btn-lg px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none', fontWeight: '600' }}>SAVE NOW!</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 text-center">
              <div style={{ fontSize: '120px' }}><img src='/images/seller/LandingBanner-removebg-preview.png'/></div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-4" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <div className="row g-4">
            {stats.map((stat, index) => (
              <div key={index} className="col-6 col-lg-3 text-center">
                <h2 className="fw-bold mb-1" style={{ color: stat.color, fontSize: '36px' }}>{stat.number}</h2>
                <p className="text-muted mb-0" style={{ fontSize: '14px' }}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Sellers Love Section */}
      <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
        <div className="container">
          <h1 className="text-center mb-4">Why do <span style={{ color: '#e63963' }}>sellers love selling on Flipkart?</span></h1>
          <p className="para text-center text-muted mb-5">At Seller HQ, we look at the entire experience to help you start, build and sustain an online business. Here is what we provide to all our sellers and aim to make their experience truly wonderful and fulfilling.</p>
          <div className="row g-4">
            <div className="col-lg-8">
              <div className="row g-4">
                {whySell.map((item, index) => (
                  <div key={index} className="col-md-6">
                    <div
                      className="p-4 whycard"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        height: "100%",
                      }}
                    >
                      <div className="mb-3 whyimg d-flex align-items-center" style={{ fontSize: "12px" }}>
                        <img src={item.img} alt={item.title} />
                        <h4 className="fw-bold mb-2 ms-2">{item.title}</h4>
                      </div>
                      <p className="text-muted mb-0" style={{ fontSize: "15px" }}>
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-4 text-center">
                <img
                src='/images/seller/position1.webp'
                className='whyright'
                />            
            </div>
          </div>
        </div>
      </section>

      {/* Seller Success Stories */}
      <section className="py-5 px-3" style={{ backgroundColor: '#fff' }}>
        <div className="container">
            <div className="row">
                <div className="col-lg-6 sellersuccess">
          <h1 className="mb-4" style={{ color: '#e63963' }}>Seller Success Stories</h1>
          <p className="para text-bold mb-4">14 Lakhs+ sellers trust Flipkart for their online success business.</p>
          <div className="row">
            <div className="col-lg-8">
              <button className="btn btn-sm mb-3 para" style={{ border: '1px solid #e63963', color: '#e63963', backgroundColor: 'white', width: '150px' }}>See All Stories</button>
            </div>
            </div>
            </div>
            <div className="col-lg-6 position-relative d-flex justify-content-center">
              <div className="seller-slider-card">

                {/* Left Arrow */}
                <button
                  className="slider-arrow left"
                  onClick={() =>
                    setCurrentStory(
                      currentStory === 0 ? stories.length - 1 : currentStory - 1
                    )
                  }
                >
                  ‹
                </button>

                {/* Right Arrow */}
                <button
                  className="slider-arrow right"
                  onClick={() =>
                    setCurrentStory(
                      currentStory === stories.length - 1 ? 0 : currentStory + 1
                    )
                  }
                >
                  ›
                </button>

                {/* Profile */}
                <div className="profile-wrap">
                  <div className="profile-bg">
                    <img
                      src={stories[currentStory].image}
                      alt={stories[currentStory].name}
                    />
                  </div>
                </div>

                <h5 className="fw-bold mt-3">
                  {stories[currentStory].name},
                </h5>
                <p className="text-muted mb-3">
                  {stories[currentStory].role}
                </p>

                <p className="story-text">
                  {stories[currentStory].quote}
                </p>

                {/* Dots */}
                <div className="dots">
                  {stories.map((_, index) => (
                    <span
                      key={index}
                      className={index === currentStory ? "dot active" : "dot"}
                      onClick={() => setCurrentStory(index)}
                    />
                  ))}
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Your Journey Section */}
      <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
        <div className="container">
          <h1 className="text-center mb-2"><span style={{ color: '#e63963' }}>Your Journey</span> on Flipkart</h1>
          <p className="para text-center text-muted mb-5">Starting your online business with us? It's super easy. Follow these 5 easy steps that you don't want to miss</p>
          <div className="row g-4">
            {journey.map((item, index) => (
              <div key={index} className="col-6 col-md-4 col-lg text-center">
                <div className="p-4 animate-on-scroll" style={{ backgroundColor: '#fff', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3"><img src={item.imgjourny} alt={item.title} className='journyimg' /></div>
                  <h3 className="fw-bold mb-2">{item.title}</h3>
                  <p className="text-muted small mb-0" style={{ fontSize: '15px' }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <button className="btn para" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963', fontWeight: '500' }}>Download Seller Kit</button>
          </div>
        </div>
      </section>

      {/* Tools Section */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <h1 className="text-center mb-2">Access our tools to <span style={{ color: '#e63963' }}>grow faster</span> on Flipkart</h1>
          <p className="para text-center text-muted mb-5">With a wide range of tools at your fingertips, we empower you to set up and manage your business seamlessly.</p>
          <div className="row g-4">
            {tools.map((tool, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="p-4 h-100 animate-on-scroll" style={{ backgroundColor: '#f7f9fc', borderRadius: '8px' }}>
                  <div className="mb-3" style={{ fontSize: '32px', display:"flex", alignItems:"center" }}><img src={tool.imgtool} alt={tool.title} className='toolimg'/><h4 className="fw-bold mb-2 ms-2">{tool.title}</h4></div>
                  <p className="text-muted small mb-3" style={{ fontSize: '15px' }}>{tool.desc}</p>
                  <a href="#" style={{ color: '#2874f0', fontSize: '13px', textDecoration: 'none' }}>Learn More →</a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Shopsy Section */}
        <section
        className="py-5 text-center"
        style={{ backgroundColor: "rgba(var(--bs-white-rgb), var(--bs-bg-opacity))" }}
        >
        <div className="container">
            <div
            className="mb-4"
            style={{ fontSize: "48px", fontWeight: "bold", color: "#6C5CE7" }}
            >
            <img
                src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png"
                alt="logo"
                className="brandlogo"
            />
            </div>

            <p className="para mb-2 fw-bold">Your gateway to selling online</p>

            <div className="row justify-content-center mt-5" style={{border:"#e63963 1px solid", borderRadius:"8px", padding:"20px"}}>
            {shopsyFeatures.map((item, index) => (
                <div key={index} className="col-md-4 mb-4">
                <div ><img src={item.imgfeature} alt={item.title} className='featureimg'/></div>
                <h5 className="fw-bold mt-3">{item.title}</h5>
                </div>
            ))}
            </div>

            <button
            className="para btn px-4 mt-3"
            style={{
                backgroundColor: "transparent",
                color: "#e63963",
                border: "1px solid #e63963",
            }}
            >
            Explore Gharshya
            </button>
        </div>
        </section>


      {/* Platform Preview */}
      <section className="py-5" style={{ backgroundColor: '#fff' }}>
        <div className="container">
          <h1 className="mb-4">Take a sneak peek 👀 into <span style={{ color: '#e63963' }}>our platform</span></h1>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h3 className="fw-bold mb-3" style={{ color: '#e63963' }}>Selection Insights</h3>
              <p className="para text-muted mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Browse through a diverse, quality goods marketplace, and take charge of the entire purchasing operation.</p>
              <button className="btn para" style={{ backgroundColor: 'transparent', color: '#e63963', border: '1px solid #e63963' }}>Explore All Features</button>
            </div>
            <div className="col-12 col-lg-6 text-center mt-4 mt-lg-0">
              <div style={{ backgroundColor: '#f7f9fc', padding: '40px', borderRadius: '8px' }}>
                <div style={{ fontSize: '40px' }}><img src="/images/seller/takesneekpeek.webp" alt="Preview" style={{width:"200px"}} /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section className="py-5" style={{ backgroundColor: '#f7f9fc' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="mb-4">We are happy to <span style={{ color: '#e63963' }}>help you 😊</span></h1>
              <p className="text-muted mb-4">Get instant solutions to your queries. Browse through our extensive FAQs or get in touch with our seller support team.</p>
              <div className="mb-3">
                <input type="text" className="form-control mb-2" placeholder="Name*" style={{ borderRadius: '4px' }} />
              </div>
              <div className="mb-3">
                <input type="email" className="form-control mb-2" placeholder="Email Address*" style={{ borderRadius: '4px' }} />
              </div>
              <div className="mb-3">
                <input type="tel" className="form-control mb-2" placeholder="Phone Number*" style={{ borderRadius: '4px' }} />
              </div>
              <button className="btn px-4" style={{ backgroundColor: '#e63963', color: '#fff', border: 'none' }}>Get a Callback</button>
            </div>
            <div className="col-lg-6 text-center mt-4 mt-lg-0">
              <div style={{ fontSize: '120px' }}><img src="/images/seller/positionlast.webp" alt="Help" /></div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ backgroundColor: '#212121', color: '#fff', padding: '60px 0 20px' }}>
        <div className="container">
          <h5 className="text-center mb-4" style={{ color: '#fff' }}>Popular categories to sell across India</h5>
          <div className="row g-4 mb-5">
            <div className="col-6 col-md-3">
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Handloom Saree</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Kurtis</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Bedsheets</p>
            </div>
            <div className="col-6 col-md-3">
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Art & Craft Tools</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>T-Shirts</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Electronics</p>
            </div>
            <div className="col-6 col-md-3">
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Sarees</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Shirts</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Footwear</p>
            </div>
            <div className="col-6 col-md-3">
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Home Decor</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Books</p>
              <p className="small mb-2" style={{ color: '#c8c8c8' }}>Furniture</p>
            </div>
          </div>
          <hr style={{ borderColor: '#444', margin: '40px 0' }} />
          <div className="text-center">
            <p className="small" style={{ color: '#c8c8c8' }}>© 2026 Gharshya</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SellerLandingPage;